import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Alert from '@mui/material/Alert';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export default function AddFine({availableWorkers}) {

const [newFine, setNewFine] = useState({});
const api_url = process.env.REACT_APP_API_URL;
const complex_name = localStorage.getItem('complex_name');
const [saveStatus, setSaveStatus] = useState("");
const [saveButtonDisable, setSaveButtonDisable] = useState(false);
const [recipientType, setRecipientType] = useState('worker');
const [availableAdmins, setAvailableAdmins] = useState([]);

useEffect(() => {
    async function fetchAdmins() {
        if (recipientType === 'user') {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
                body: JSON.stringify({ complex_name })
            };
            const response = await fetch(api_url + "/api/availableAdmins", requestOptions);
            const body = await response.json();
            setAvailableAdmins(body.map(({ user_id, fullname }) => ({ userId: user_id, fullName: fullname })));
        }
    }
    fetchAdmins();
    setNewFine({ ...newFine, recipientId: '' });
}, [recipientType]);

function handleChange(e) {
    setNewFine({
      ...newFine,
      [e.target.name]: e.target.value
    });
}

async function createFine() {
    setSaveButtonDisable(true);

    let full_name;
    let requestBody;

    if (recipientType === 'worker') {
        let worker_info = availableWorkers.find((s) => s.workerId === newFine.recipientId);
        full_name = worker_info.fullName;
        requestBody = {
            worker_id: newFine.recipientId,
            recipient_type: 'worker',
            full_name,
            fine_amount: newFine.fineAmount,
            complex_name,
            comment: newFine.comment
        };
    } else {
        let user_info = availableAdmins.find((s) => s.userId === newFine.recipientId);
        full_name = user_info.fullName;
        requestBody = {
            user_id: newFine.recipientId,
            recipient_type: 'user',
            full_name,
            fine_amount: newFine.fineAmount,
            complex_name,
            comment: newFine.comment
        };
    }

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
        body: JSON.stringify(requestBody)
    };

    const saving_fine = await fetch(api_url+"/api/addFine", requestOptions);

    const body = await saving_fine.json();
    if (body.message === "Fine added successfully!") {
      setSaveStatus("success");
    }
    else {
      setSaveStatus("error");
      setSaveButtonDisable(false);
    }
}

return (
    <div className='edit-worker-modal'>
    <h1 className="modal-header"> Добавить штраф </h1>
      <Box sx={{ maxWidth: 550, margin: `auto`, pt: 5, pb: 5 }}>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel id="recipient-type-label">Тип получателя:</InputLabel>
        <Select
          value={recipientType}
          label="Тип получателя:"
          onChange={(e) => setRecipientType(e.target.value)}
        >
        <MenuItem value="worker">Мойщик/Кассир/КК</MenuItem>
        <MenuItem value="user">Админ/HR-директор</MenuItem>
        </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel id="recipient-select-label">Сотрудник:</InputLabel>
        <Select
          value={newFine.recipientId || ''}
          label="Сотрудник:"
          name="recipientId"
          fullWidth
          onChange={handleChange}
        >
        {recipientType === 'worker'
          ? availableWorkers.map(({workerId, fullName}) => (
              <MenuItem key={workerId} value={workerId}> {fullName} </MenuItem>
            ))
          : availableAdmins.map(({userId, fullName}) => (
              <MenuItem key={userId} value={userId}> {fullName} </MenuItem>
            ))
        }
        </Select>
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">Сумма</InputLabel>
        <OutlinedInput
          name="fineAmount"
          value={newFine.fineAmount || ''}
          onChange={handleChange}
          label="Сумма"
        />
        </FormControl>

        <FormControl sx={{mb:1.5, mt:1.5}} fullWidth >
        <InputLabel htmlFor="component-outlined">Комментарий</InputLabel>
        <OutlinedInput
          id="comment"
          name="comment"
          value={newFine.comment || ''}
          onChange={handleChange}
          label="Комментарий"
        />
        </FormControl>

        <Button variant="contained"
            sx={{mb:1.5, mt:1.5}} fullWidth
            disabled={saveButtonDisable}
            color="success"
            className="mr10"
            onClick={() => createFine()}>Добавить штраф</Button>
        {saveStatus === "error" && <Alert severity="error">Ошибка, проверьте правильность введенных данных!</Alert>}
        {saveStatus === "success" && <Alert severity="success">Изменения успешно сохранены!</Alert>}
        </Box>
    </div>
)}
